module.exports = "<ngx-loading [show]=\"loading\" [config]=\"{ backdropBorderRadius: '3px' }\"></ngx-loading>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/googleroute/googleroute.component.html
// module id = ./src/app/auth/googleroute/googleroute.component.html
// module chunks = main